import {Component, Input} from "@angular/core";
import {LookupService} from "../../../lookup.service";
import {RiskFactor} from "../../../../../model/lookup-results.model";

@Component({
  selector: "admin-lookup-common-factor",
  templateUrl: "./factors.component.html",
  styleUrls: ["./factors.component.css"]
})
export class AdminLookupCommonFactorComponent {

  @Input() factor: RiskFactor

  modalTitle: string;

  constructor(
    private singleService: LookupService,
  ) {
  }

  modalTitleReceiver(title: string) {
    this.modalTitle = title;
  }

}
